import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { PageHeader } from '@/components/core';
import { MenuFormDialog } from '../../components/menu-form-dialog/menu-form-dialog';
import { MenuTable } from '../../components/menu-table/menu-table';
import { useGetLunchMenus } from '../../hooks/use-manage-lunch';
import { LunchMenusResult } from '../../types/manage-lunch.types';

/**
 * Settings › Meals › Menu (HR Module Navigation Map; was Manage Lunch › Food Menu): the menus HR/Admin
 * set up for each weekday, which employees choose from on Order Meal.
 */
export const MealMenuPage = () => {
  const { t } = useTranslation();
  const [isMenuFormOpen, setIsMenuFormOpen] = useState(false);
  const { data, isLoading } = useGetLunchMenus({ pageNo: 1, pageSize: 100, filter: {} });
  const menus = (data as { LunchMenus?: LunchMenusResult })?.LunchMenus?.items ?? [];

  return (
    <div className="flex w-full flex-col gap-4">
      <PageHeader
        title={t('MEAL_MENU')}
        actions={[
          {
            label: t('ADD_MENU'),
            icon: <Plus className="size-5" />,
            onClick: () => setIsMenuFormOpen(true),
          },
        ]}
      />
      <MenuTable menus={menus} isLoading={isLoading} />
      <MenuFormDialog open={isMenuFormOpen} onOpenChange={setIsMenuFormOpen} />
    </div>
  );
};
